import { HttpClient } from '@adapters/HttpClient';

export class ShopApiAdapter {
    constructor(private httpClient: HttpClient) { }

    async getAll(): Promise<any[]> {
        const queryObj: Record<string, string> = {
            per_page: '100',
        };
        const query = new URLSearchParams(queryObj).toString();
        const raw = await this.httpClient.get<any>(`/shops?${query}`);
        const list = Array.isArray(raw) ? raw : (raw.data ?? []);
        // Filtrar shops duplicados por id
        const unique = list.filter(
            (shop: any, idx: number, arr: any[]) =>
                arr.findIndex((s) => String(s.id) === String(shop.id)) === idx
        );
        return unique; // Devuelve el objeto completo
    }

    async getProductsByShop(
        shopId: string
    ): Promise<{ id: string; name: string; variant_id?: string | number; variants?: Array<{ id: number; title: string }> }[]> {
        const response = await this.httpClient.get<any>(
            `/shops/${shopId}/products`
        );
        const list = Array.isArray(response) ? response : (response.data ?? []);
        return list.map((prod: any) => ({
            id: String(prod.id),
            name: prod.title || prod.name,
            variant_id: prod.variant_id,
            variants: prod.variants || [],
        }));
    }

    async getVariantsByProduct(
        shopId: string,
        productId: string
    ): Promise<{ id: string; name: string }[]> {
        const response = await this.httpClient.get<any>(
            `/shops/${shopId}/product/${productId}/variants`
        );
        const list = Array.isArray(response) ? response : (response.data ?? []);
        return list.map((variant: any) => ({
            id: String(variant.id),
            name: variant.title || variant.name,
        }));
    }
}

